import { host, SDK_INFO, socketRoomName } from "./socketConfig";
import io from 'socket.io-client'
import useSocketCall, { fillDataCall } from "hook/useSocketCall";
import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";

const socket = io(host, {
  path: '/market/socket.io',
  transports: ['websocket'],
  query: SDK_INFO,
  autoConnect: true
});

socket.on("connect", () => {
  // console.log('Socket connected');
  // fetchInformationStock(StocksAnalysisStore?.inputSearch)
});

socket.on("connection", () => {
  // console.log('Socket connection');
});

socket.on("open", (e) => {
  // console.log('server open', e);
});

socket.on("message", (e) => {
  // console.log('server message', e);
});


socket.on("pong", (e) => {
  // console.log('server pong', e);
});

socket.on("close", (e) => {
  // console.log('server close', e);
});

socket.on("error", (e) => {
  // console.log('server error', e);
});

function socketIoSetup() {
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore);
  const { fetchSubscribeStock } = useSocketCall(socket)

  useEffect(() => {
    if (StocksAnalysisStore?.inputSearch) {
      fetchSubscribeStock(StocksAnalysisStore?.inputSearch)
    }
  }, [StocksAnalysisStore?.inputSearch])

  return { socket }
}

export default socketIoSetup;